import { Injectable } from '@angular/core';
import * as angular from 'angular';
import { AppSettingsService } from '../appSettings/AppSettingsService';

/**
 * Logs client errors to the backend
 */

@Injectable({
    providedIn: 'root'
})
export class LoggingService {
    public static $name: string = 'loggingService';

    constructor(
        private appSettingsService: AppSettingsService
    ) {
    }

    public logError(exception: angular.IException, cause: angular.IExceptionCause) {
        if (this.appSettingsService.getMetadata().isDebugEnabled) {
            return;
        }

        let message: string;
        let stack: string;

        if (angular.isObject(exception)) {
            message = exception.message;
            stack = exception.stack;
        } else {
            message = exception;
        }

        let data: CASLink.Infrastructure.Ui.ViewModel.ClientErrorViewModel = {
            cause: cause as any,
            clientUrl: window.location.href, // can't use $location due to circular dependencies
            message: message,
            stack: stack
        };

        // Can't use $http or proxyService due to circular dependencies
        $.post('api/clientLogging/error', data);
    }
}
